import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StatsComponent from '../components/shared/stats_component'
import { GGButton } from '../../shared/new_components/GGButton'
import { GGInput } from '../../shared/new_components/GGInput'
import GgGolfHubPopupNotification from '../components/shared/gg_golf_hub_popup_notification'
import { hideMemberPopup, showMemberFormPopupNewGolfer } from '../actions/dashboard/members_index'
import MembersTableComponent from '../components/dashboard/members_table_component'
import MemberFormPopup from '../components/dashboard/member_form_popup'
import { NotificationContainer } from 'react-notifications'
import { callAPI } from '../../shared/helpers'

const GgGolfHubEventRosterComponent = () => {
  const dispatch = useDispatch()
  const paths = useSelector(state => state.paths)
  const leagueName = useSelector(state => state.leagueName)
  const entryFees = useSelector(state => state.entryFees)
  const totalMembers = useSelector(state => state.totalMembers)
  const membersDataLoaded = useSelector(state => state.membersDataLoaded)
  const showMemberPopup = useSelector(state => state.showMemberPopup)
  const memberPopupText = useSelector(state => state.memberPopupText)
  const members = useSelector(state => state.members)
  const showMemberFormPopup = useSelector(state => state.showMemberFormPopup)
  const memberFormPopupText = useSelector(state => state.memberFormPopupText)

  const printPath = paths.downloadRoster
  const backPath = paths.backToCustomer

  const [searchInput, setSearchInput] = useState('')
  const [width, setWidth] = useState(window.innerWidth)
  const [isDownloading, setIsDownloading] = useState(false)
  const pollTimeoutRef = useRef(null)

  useEffect(() => {
    // Lock page scroll with overflow, not position: fixed — a positioned
    // <body> becomes the containing block for the tether-portaled GGMenu
    // panels and breaks their placement (RTM-9649).
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize, false)
    return () => window.removeEventListener('resize', handleResize, false)
  }, [])

  useEffect(() => {
    return () => { clearTimeout(pollTimeoutRef.current) }
  }, [])

  const downloadFile = (url) => {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.style.display = 'none'
    a.href = url
    a.click()
    document.body.removeChild(a)
  }

  const pollJob = (jobId) => {
    pollTimeoutRef.current = setTimeout(() => {
      callAPI(paths.jobPoll.replace('_JOB_ID_', jobId), 'GET')
        .then((messages) => {
          const lastMessage = messages[messages.length - 1]
          if (lastMessage?.type === 'job-update' && lastMessage?.value?.status === 'completed') {
            downloadFile(lastMessage.value.pdf_path)
            setIsDownloading(false)
          } else if (lastMessage?.value?.status === 'errors') {
            setIsDownloading(false)
          } else {
            pollJob(jobId)
          }
        })
        .catch(() => setIsDownloading(false))
    }, 1000)
  }

  const handleDownload = () => {
    setIsDownloading(true)
    callAPI(printPath, 'GET', { format: 'json' })
      .then((data) => {
        if (data.job_id) {
          pollJob(data.job_id)
        }
      })
      .catch(() => setIsDownloading(false))
  }

  const t = (key) => (!window.I18n ? '' : window.I18n.t(`gg_golf_hub.event_roster.${key}`))

  const isMobile = width <= 992
  const buttonClass = isMobile ? 'flex-1' : ''
  const buttonsJSX = (
    <>
      <div className={`add-margin-right-20 ${buttonClass}`}>
        <GGButton
          label={t('add')}
          icon='square-plus-o'
          onClick={() => dispatch(showMemberFormPopupNewGolfer())}
        />
      </div>
      <div className={buttonClass}>
        <GGButton
          label={isDownloading ? t('downloading') : t('download')}
          icon='download-o'
          usePro
          disabled={members.length === 0}
          isLoading={isDownloading}
          onClick={handleDownload}
        />
      </div>
    </>
  )

  return (
    <div className='members-component'>
      <NotificationContainer/>
      <GgGolfHubPopupNotification isOpen={showMemberPopup} text={memberPopupText} onClose={() => dispatch(hideMemberPopup())} />
      <div className='back-button'>
        <GGButton
          label={t('back')}
          icon='arrow-left-o'
          usePro
          variant='ghost'
          onClick={() => { window.location.href = backPath }}
        />
      </div>
      <div className='roster-header'>
        <div className='roster-header-title'>
          <h3 className='roster-title'>{t('registered_golfers')}</h3>
          <span className='roster-subtitle'>{leagueName}</span>
        </div>
        { width > 992 && <div className='flex-div'>{ buttonsJSX }</div> }
      </div>
      <div className='main-div'>
        <div className='flex-div'>
          <div style={{ width: '280px' }}>
            <GGInput
              name='roster-search'
              placeholder={t('search')}
              icon='magnifying-glass'
              value={searchInput}
              onChange={setSearchInput}
            />
          </div>
          <div className={isMobile ? 'add-margin-top-10' : 'add-margin-left-20'}>
            {membersDataLoaded && <StatsComponent numberOfGolfers={totalMembers} entryFeesSum={entryFees} isUsedInMembers={true}/>}
          </div>
        </div>
      </div>
      <MembersTableComponent searchInput={searchInput} width={width} />
      {showMemberFormPopup && <div>
        <MemberFormPopup
          active={showMemberFormPopup}
          title={memberFormPopupText}
        />
      </div>}
      { isMobile && (
        <div className='save_bar_light'>
          { buttonsJSX }
        </div>
      ) }
    </div>

  )
}

export default GgGolfHubEventRosterComponent
